<template>
  <div id="app">
    <el-container class="app-container">
      <el-aside width="240px" class="app-sidebar">
        <div class="logo-container">
          <img src="https://file.gaolianonline.com/gaolianseat20a7fa519c434b5a876179a5367a479c.png" alt="高联logo" class="logo-img">
          <h2 class="logo-text">AI文章管理系统</h2>
        </div>
        
        <el-menu 
          router 
          :default-active="$route.path"
          background-color="#304156"
          text-color="#BFCBD9"
          active-text-color="#409EFF"
          class="sidebar-menu">
          
          <div class="menu-header">主导航</div>
          
          <el-menu-item index="/dashboard" class="menu-item">
            <i class="el-icon-s-home menu-icon"></i>
            <span slot="title">控制台</span>
          </el-menu-item>
          
          <div class="menu-header">内容管理</div>
          
          <el-submenu index="/articles" class="menu-item">
            <template slot="title">
              <i class="el-icon-document menu-icon"></i>
              <span>文章管理</span>
            </template>
            <el-menu-item index="/articles" class="submenu-item">
              <i class="el-icon-s-order menu-icon"></i>
              <span>所有文章</span>
            </el-menu-item>
            <!-- <el-menu-item index="/categories" class="submenu-item">
              <i class="el-icon-collection-tag menu-icon"></i>
              <span>分类管理</span>
            </el-menu-item> -->
            <el-menu-item index="/articles/create" class="submenu-item">
              <i class="el-icon-plus menu-icon"></i>
              <span>创建文章</span>
            </el-menu-item>
          </el-submenu>
          
          <el-menu-item index="/image-library" class="menu-item">
            <i class="el-icon-picture menu-icon"></i>
            <span slot="title">图片库</span>
          </el-menu-item>
          
          <div class="menu-header">AI助手</div>
          
          <el-menu-item index="/ai-settings" class="menu-item">
            <i class="el-icon-setting menu-icon"></i>
            <span slot="title">AI设置</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      
      <el-container class="main-container">
        <el-header class="app-header">
          <div class="header-left">
            <i class="el-icon-s-fold toggle-sidebar" @click="toggleSidebar"></i>
            <el-breadcrumb separator="/">
              <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item v-if="$route.meta && $route.meta.title">{{ $route.meta.title }}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          
          <div class="header-right">
            <el-dropdown trigger="click" class="user-dropdown">
              <span class="user-info">
                <i class="el-icon-user-solid avatar"></i>
                <span>管理员</span>
                <i class="el-icon-caret-bottom"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>个人中心</el-dropdown-item>
                <el-dropdown-item divided>退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-header>
        
        <el-main class="app-main">
          <transition name="fade-transform" mode="out-in">
            <router-view />
          </transition>
        </el-main>
        
        <el-footer class="app-footer">
          <p>高联AI文章生成系统 © {{ new Date().getFullYear() }} 高联教育</p>
        </el-footer>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      isCollapse: false
    };
  },
  methods: {
    toggleSidebar() {
      this.isCollapse = !this.isCollapse;
      document.body.classList.toggle('sidebar-collapse', this.isCollapse);
    }
  }
};
</script>

<style>
/* 全局样式 */
body {
  margin: 0;
  padding: 0;
  height: 100%;
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f0f2f5;
}

#app {
  height: 100vh;
}

/* 布局容器样式 */
.app-container {
  height: 100%;
}

/* 侧边栏样式 */
.app-sidebar {
  background-color: #304156;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  transition: width 0.3s;
  overflow-x: hidden;
  z-index: 10;
}

.logo-container {
  height: 60px;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  background-color: #2b3649;
  overflow: hidden;
}

.logo-img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-right: 10px;
}

.logo-text {
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  white-space: nowrap;
  margin: 0;
}

.sidebar-menu {
  border-right: none;
  height: calc(100% - 60px);
  padding-top: 10px;
}

.menu-header {
  color: #808695;
  font-size: 12px;
  padding: 15px 16px 5px;
  margin-top: 5px;
}

.menu-item {
  margin-bottom: 4px;
}

.menu-icon {
  margin-right: 10px;
  font-size: 18px;
  width: 24px;
  text-align: center;
}

.submenu-item {
  padding-left: 54px !important;
}

.el-submenu__title {
  padding-left: 20px !important;
}

.el-menu-item {
  padding-left: 20px !important;
}

/* 主容器样式 */
.main-container {
  min-height: 100%;
  position: relative;
  background-color: #f0f2f5;
}

/* 顶栏样式 */
.app-header {
  background-color: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  height: 60px !important;
}

.header-left {
  display: flex;
  align-items: center;
}

.toggle-sidebar {
  font-size: 20px;
  cursor: pointer;
  margin-right: 15px;
  color: #606266;
}

.header-right {
  display: flex;
  align-items: center;
}

.user-dropdown {
  cursor: pointer;
}

.user-info {
  display: flex;
  align-items: center;
}

.avatar {
  font-size: 20px;
  background: #409EFF;
  color: #fff;
  border-radius: 50%;
  padding: 4px;
  margin-right: 8px;
}

/* 主内容区域样式 */
.app-main {
  padding: 20px;
  min-height: calc(100vh - 120px);
}

/* 页脚样式 */
.app-footer {
  text-align: center;
  font-size: 14px;
  color: #606266;
  background-color: #fff;
  border-top: 1px solid #e6e6e6;
  padding: 15px 0;
  height: auto !important;
}

/* 路由切换动画 */
.fade-transform-enter-active,
.fade-transform-leave-active {
  transition: all 0.3s;
}

.fade-transform-enter,
.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(20px);
}

/* 响应式调整 */
@media (max-width: 768px) {
  .app-sidebar {
    width: 64px !important;
  }
  
  .logo-text {
    display: none;
  }
  
  .app-main {
    padding: 15px;
  }
}

/* 侧边栏收起状态 */
body.sidebar-collapse .app-sidebar {
  width: 64px !important;
}

body.sidebar-collapse .logo-text {
  display: none;
}

body.sidebar-collapse .menu-header {
  padding: 15px 15px 5px;
  overflow: hidden;
  text-overflow: clip;
  white-space: nowrap;
}
</style>